import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppDispatch, RootState } from '../../../../app/store';
import { Messages } from '../../../../Constants/Messages';
import { showErrorSnackbar } from '../../../../component/snackbar/Snackbar.slice';
import { getEnormousUploadDetails } from '../../../../component/UploadReportsDialog/UploadReportsDialog.api';

export enum EnormousFileUploadStatus {
	NotStarted = 0,
	InProgress = 1,
	Complete = 2,
	Failed = 3
}

export interface EnormousFileUpload {
	ImportId: string;
	ClientId: string;
	JobId: string;
	status: EnormousFileUploadStatus;
}

export interface UploadData {
	clientId: string;
	jobId: string;
	importId: string;
}

interface State {
	enormousFileUploadsData: EnormousFileUpload[];
	isEnormousFileUploaded: Boolean;
}

const initialState: State = {
	enormousFileUploadsData: [],
	isEnormousFileUploaded: false,
};

export const fetchEnormousFileUploadsData = createAsyncThunk<
	void,
	void,
	{
		dispatch: AppDispatch;
		state: RootState;
	}
>('enormousFileUploads/fetchEnormousFileUploadsData', async (_, thunkAPI) => {
	await getEnormousUploadDetails().then(function (result) {
		if (!result.Success) {
			showErrorSnackbar(thunkAPI.dispatch, Messages.EXCEPTION_FOR_FETCH);
			return;
		}
		let jsonData = result.Data.toString();
		jsonData = jsonData.replaceAll('"importId"', '"ImportId"')
			.replaceAll('"clientId"', '"ClientId"')
			.replaceAll('"jobId"', '"JobId"');
		let uploadData = JSON.parse(jsonData) as EnormousFileUpload[];
		thunkAPI.dispatch(setEnormousFileUploadsData(uploadData));
	}).catch((error) => {
		showErrorSnackbar(thunkAPI.dispatch, Messages.EXCEPTION_FOR_FETCH);
	});
});

const enormousFileUploadsDataSlice = createSlice({
	name: 'enormousFileUploads',
	initialState,
	reducers: {
		setEnormousFileUploadsData: (state, action: PayloadAction<EnormousFileUpload[]>) => {
			state.enormousFileUploadsData = action.payload;
		},
		setEnormousFileUpload: (state, action: PayloadAction<Boolean>) => {
			state.isEnormousFileUploaded = action.payload;
		},
	},
});

export const { setEnormousFileUploadsData, setEnormousFileUpload } = enormousFileUploadsDataSlice.actions;
export default enormousFileUploadsDataSlice.reducer;
